import React, { memo } from 'react';
import { connect } from 'react-redux';

import { getItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME } from 'src/reducers/desk/syncWithAttendance';

const ResponseMessage = ({ item }) => (
  <>
    {item?.status &&
      item?.text && (
        <div className="row">
          <div className="col-12">
            <div className={`alert alert-${item?.status === 200 ? 'success' : 'danger'}`} role="alert">
              {item?.text}
              <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      )}
  </>
);

const mapStateToProps = state => ({
  item: getItem(REDUCER_NAME, state)
});

export default memo(connect(mapStateToProps)(ResponseMessage));
